import { theme } from '@atlas/shared/client/ui/core/theming';
import { unsafeCSS, css } from 'lit';

export const focusBorderMixin = (selector = '&') =>
    css`
        &:focus {
            ${unsafeCSS(selector)} {
                outline-offset: 3px;
                outline: 3px solid ${unsafeCSS(theme.colors.semantic.focus)};
            }
            &:not(:focus-visible) {
                ${unsafeCSS(selector)} {
                    outline: none;
                }
            }
        }
    `;
